import { render, staticRenderFns } from "./m-editShortAnswerChild.vue?vue&type=template&id=444d63be&"
import script from "./m-editShortAnswerChild.vue?vue&type=script&lang=js&"
export * from "./m-editShortAnswerChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports